import { graphql, useStaticQuery } from "gatsby"

interface QueryResult {
  siteTrustedValues: {
    content: Storyblok.SiteTrustedValues | string
  }
}

export interface TrustedValue {
  value?: number
  suffix: string
}

interface SiteTrustedValues {
  trustedByNumBusinesses: TrustedValue
  trustedByNumUsers: TrustedValue
}

const EMPTY_TRUSTED_VALUE: TrustedValue = { value: undefined, suffix: "" }

const parseTrustedValue = (raw?: string): TrustedValue => {
  if (!raw) return EMPTY_TRUSTED_VALUE

  const digitsOnly = raw.replace(/\D/g, "")
  if (!digitsOnly) return EMPTY_TRUSTED_VALUE

  const value = Number(digitsOnly)
  if (!Number.isFinite(value)) return EMPTY_TRUSTED_VALUE

  const lastDigitIndex = raw.search(/\d(?!.*\d)/)
  const suffix = raw.slice(lastDigitIndex + 1).trim()

  return { value, suffix }
}

const useSiteTrustedValues = (): SiteTrustedValues => {
  const queryResult: QueryResult = useStaticQuery(graphql`
    query {
      siteTrustedValues {
        content
      }
    }
  `)

  const content = queryResult?.siteTrustedValues?.content
  const parsedContent: Partial<Storyblok.SiteTrustedValues> =
    typeof content === "string"
      ? (JSON.parse(content) as Storyblok.SiteTrustedValues)
      : (content ?? {})

  return {
    trustedByNumBusinesses: parseTrustedValue(
      parsedContent.trustedByNumBusinesses
    ),
    trustedByNumUsers: parseTrustedValue(parsedContent.trustedByNumUsers),
  }
}

export default useSiteTrustedValues
